var _rect, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    x: 0.5,
    y: 0.5,
    fill: "#0b84cb",
    rx: 19.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.88 10.254c-.041-.046-1.535.019-2.835 1.43-1.3 1.41-1.1 3.026-1.07 3.068.029.041 1.853.106 3.017-1.534 1.165-1.64.93-2.916.888-2.964m4.042 14.308c-.06-.117-2.836-1.505-2.577-4.173.258-2.67 2.042-3.4 2.07-3.48s-.728-.963-1.529-1.411a4.5 4.5 0 0 0-1.906-.53c-.131-.003-.589-.115-1.529.142-.62.17-2.016.718-2.4.74-.385.022-1.531-.636-2.764-.81-.79-.153-1.626.16-2.224.4-.598.239-1.735.919-2.53 2.727s-.379 4.67-.081 5.561c.297.889.762 2.346 1.552 3.41.702 1.2 1.634 2.032 2.023 2.315s1.487.47 2.247.082c.613-.376 1.717-.591 2.154-.576.435.016 1.294.188 2.173.658.696.24 1.355.14 2.015-.128.66-.27 1.614-1.292 2.729-3.364q.635-1.444.577-1.563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.88 10.254c-.041-.046-1.535.019-2.835 1.43-1.3 1.41-1.1 3.026-1.07 3.068.029.041 1.853.106 3.017-1.534 1.165-1.64.93-2.916.888-2.964m4.042 14.308c-.06-.117-2.836-1.505-2.577-4.173.258-2.67 2.042-3.4 2.07-3.48s-.728-.963-1.529-1.411a4.5 4.5 0 0 0-1.906-.53c-.131-.003-.589-.115-1.529.142-.62.17-2.016.718-2.4.74-.385.022-1.531-.636-2.764-.81-.79-.153-1.626.16-2.224.4-.598.239-1.735.919-2.53 2.727s-.379 4.67-.081 5.561c.297.889.762 2.346 1.552 3.41.702 1.2 1.634 2.032 2.023 2.315s1.487.47 2.247.082c.613-.376 1.717-.591 2.154-.576.435.016 1.294.188 2.173.658.696.24 1.355.14 2.015-.128.66-.27 1.614-1.292 2.729-3.364q.635-1.444.577-1.563"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    x: 0.5,
    y: 0.5,
    stroke: "#d4ebfd",
    rx: 19.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.074 10.245h19.853v19.511H10.074z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/appleLogo.da910625f96dfe300c684a5c14f2f649.svg";
export { ForwardRef as ReactComponent };